export class orgao {
    public id: string | null;
    public codigo: string | undefined;
    public descricao: string;
    public codigoCentralizado: string;
    public nomeApresentacao: string;
    public ordenacaoOrgao: boolean;
    public posicaoOrdenacao:number;

    constructor(id: string | null = null,
      codigo: string | undefined = undefined,
      descricao: string = "",
      codigoCentralizado: string = "",
      nomeApresentacao: string = "",
      ordenacaoOrgao: boolean =false,
      posicaoOrdenacao: number| undefined= 0
    ) {
      this.id = id;
      this.codigo = codigo;
      this.descricao = descricao;
      this.codigoCentralizado = codigoCentralizado;
      this.nomeApresentacao = nomeApresentacao;
      this.ordenacaoOrgao = ordenacaoOrgao;
      this.posicaoOrdenacao=posicaoOrdenacao;
    }
}